// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4007":"74daa11e0b8f7cf4","7466":"66c01a189ab99b1d"}[chunkId] + ".css";
};